import { z } from 'zod';

export const StarterTagSchema = z.object({
  tag: z.string(),
  count: z.number(),
});

export type StarterTag = z.infer<typeof StarterTagSchema>;

export const StarterTagValueSchema = z.object({
  value: z.string(),
  count: z.number(),
});

export type StarterTagValue = z.infer<typeof StarterTagValueSchema>;
